import { cn } from "@/lib/utils";
import { forwardRef, useState } from "react";

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  containerClassName?: string;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ src, alt, containerClassName, className, ...props }, ref) => {
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
      setLoading(false);
    };

    return (
      <div className={cn("relative", containerClassName)}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-200 animate-pulse"></div>
        )}
        <img
          ref={ref}
          src={src}
          alt={alt}
          onLoad={handleLoad}
          className={cn(
            "w-full h-full object-cover transition-opacity duration-300",
            loading ? "opacity-0" : "opacity-100",
            className
          )}
          {...props}
        />
      </div>
    );
  }
);

export { Image };
